import { TimeSpan } from '../media-player';
import { HistogramBucket } from './histogram-bucket';

/**
 * Histogram representing which parts of the video the user
 * watched
 */
export class PlaybackHistogram {

    private min: number;
    private max: number;
    private readonly numberOfBuckets: number;
    private readonly bucketSize: number;
    private readonly values: HistogramBucket[] = [];

    constructor(min: number, max: number, buckets: number) {
        this.min = min;
        this.max = max;
        this.numberOfBuckets = buckets;
        this.bucketSize = (max - min) / buckets;
        this.values = [];
        for (let i = 0; i < this.numberOfBuckets; i++) {
            this.values.push(new HistogramBucket(i, 0));
        }
    }

    /**
     * Map the played timespan to corresponding buckets, this is
     * used to produce a histogram that exposes how many times
     * the used played certain portions of the video
     * @param span
     */
    map(span: TimeSpan): HistogramBucket[] {
        const startBucket: number = Math.round(span.start / this.bucketSize);
        const endBucket: number = Math.round(span.end / this.bucketSize);
        const mapped: HistogramBucket[] = [];
        for (let i = startBucket; i < endBucket; i++) {
            mapped.push(new HistogramBucket(i, 1));
        }
        return mapped;
    }

    /**
     * Merge the histogram obtained by mapping the played TimeSpan
     * with the current playback histogram
     * @param span
     */
    add(span: TimeSpan): void {
        const buckets: HistogramBucket[] = this.map(span);
        for (let bucket of buckets) {
            this.values[bucket.id].value += bucket.value;
        }
    }

    /**
     * Increment bucket
     * @param id
     */
    increment(id: number): void {
        this.values[id].value += 1;
    }

    /**
     * @param bucketId
     */
    getStartPosition(bucketId: number): number {
        return bucketId * this.bucketSize;
    }
}

